<template>
	<NuxtLayout>
		<NuxtPage />
	</NuxtLayout>
</template>

<script>
import { onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import EventBus from '@/components/app/AppEventBus';
import { useLocalesStore } from "@/stores/i18n";

export default {
	setup() {
		const localesStore = useLocalesStore();

		// Initialize the locale before the component is mounted
		onBeforeMount(() => {
			localesStore.initLocale();
		});

		// Dark mode toggle listener and event setup
		const darkModeToggleListener = (event) => {
			if (!document.startViewTransition) {
				toggleDarkMode(event);
				return;
			}
			document.startViewTransition(() => toggleDarkMode(event));
		};

		const toggleDarkMode = (event) => {
			const isDark = event.dark;
			if (isDark) document.documentElement.classList.add('p-dark');
			else document.documentElement.classList.remove('p-dark');
			this.$appState.darkTheme = isDark;
			EventBus.emit('dark-mode-toggle-complete');
		};

		onMounted(() => {
			EventBus.on('dark-mode-toggle', darkModeToggleListener);
			document.body.classList.add('loaded');
		});

		onBeforeUnmount(() => {
			EventBus.off('dark-mode-toggle', darkModeToggleListener);
		});
	},
};
</script>

<style lang="scss"></style>
